export var StudentReferralTool = /*#__PURE__*/function (StudentReferralTool) {
  StudentReferralTool[StudentReferralTool["DirectStudentSignup"] = 1] = "DirectStudentSignup";
  StudentReferralTool[StudentReferralTool["AddNewStudentModal"] = 2] = "AddNewStudentModal";
  StudentReferralTool[StudentReferralTool["InviteStudentLink"] = 3] = "InviteStudentLink";
  StudentReferralTool[StudentReferralTool["EmbeddableSearch"] = 4] = "EmbeddableSearch";
  StudentReferralTool[StudentReferralTool["BulkImport"] = 5] = "BulkImport";
  StudentReferralTool[StudentReferralTool["StudentIntakeForm"] = 6] = "StudentIntakeForm";
  return StudentReferralTool;
}({});
export var SERVICE_OF_INTEREST_DATA = [
// Values should be passed as integers to the create
// student API rather than strings.
{
  value: 1,
  label: 'Programs'
}, {
  value: 2,
  label: 'Scholarships'
}, {
  value: 3,
  label: 'Visa Services'
}, {
  value: 4,
  label: 'Insurance'
}, {
  value: 5,
  label: 'Accommodation'
}, {
  value: 6,
  label: 'Bank Accounts'
}, {
  value: 7,
  label: 'Tourism'
}, {
  value: 8,
  label: 'Other'
}];
export var DEFAULT_FORM_VALUES = {
  firstName: '',
  lastName: '',
  birthDate: '',
  middleName: '',
  email: '',
  gender: '',
  didStudentConsent: false,
  blocked: false,
  countryOfCitizenship: '',
  passportNumber: '',
  passportExpiryDate: '',
  phoneNumber: '',
  leadStatus: '',
  leadSource: '',
  customLeadSource: '',
  countryOfInterest: [],
  servicesOfInterest: [],
  passportFile: []
};
export var DEFAULT_INPUT_LENGTH_LIMIT = 120;
export var MAX_PASSPORT_INPUT_LIMIT = 20;
export var MIN_PHONE_NUMBER_LENGTH = 6;
export var SUSPENDED_RP_DIALOG_TITLE = 'Add new student';
export var SUSPENDED_RP_DIALOG_NOTICE_MESSAGE = ' This account has been suspended, and you cannot add new students at this time.';
export var SUSPENDED_RP_DIALOG_INSTRUCTION = 'Please reach out to your ApplyBoard account manager directly or via partnership@applyboard.com.';